import LightLogo from '@/assets/light-theme/logo.png';
import DarkLogo from '@/assets/dark-theme/logo.png';
import LightXmasLogo from '@/assets/light-theme/xmas_logo.png';
import DarkXmasLogo from '@/assets/dark-theme/xmas_logo.png';

import { useTheme } from '@/shared/providers/ThemeProvider';
import { useLocation } from '@tanstack/react-router';
import { useSeasonalFlags } from '@/shared/providers/SeasonalFlagsProvider';

export const publicRoutes = ['/login', '/logout', '/'];

/** The logo for light backgrounds, whatever the theme. It follows the Christmas theme. */
export function useLightAppLogo(): string {
  const { xmasEnabled } = useSeasonalFlags();
  return xmasEnabled ? LightXmasLogo : LightLogo;
}

/** The logo for the current theme. Public routes always use the light one. */
export function useAppLogo(): string {
  const { isDark } = useTheme();
  const { xmasEnabled } = useSeasonalFlags();
  const location = useLocation();
  const isPublic = publicRoutes.includes(location.pathname);
  if (isDark && !isPublic) return xmasEnabled ? DarkXmasLogo : DarkLogo;
  return xmasEnabled ? LightXmasLogo : LightLogo;
}
